import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { categories } from "../data/categories";
import "./Products.css";

export default function Products() {
  return (
    <section id="products" className="products-section">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">Our Collection</p>
          <h2 className="section-title">Handcrafted for every outdoor space</h2>
          <p className="section-lead">
            Discover our collection of premium outdoor products, thoughtfully crafted to elevate
            every outdoor space.
          </p>
        </div>

        <div className="products-grid">
          {categories.map((category) => (
            <Link to={`/products/${category.slug}`} key={category.slug} className="product-card">
              <div className="product-image">
                <img src={category.cardImage} alt={category.title} loading="lazy" />
              </div>

              <div className="product-info">
                <h3>{category.title}</h3>

                <ul className="product-short-info">
                  {category.shortInfo.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>

                <span className="btn explore-btn">
                  Explore Products <ArrowRight size={16} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
